import React, { useEffect, useState } from "react";
import { getCustomers, getVehicles } from "../../api/apiGetrequest";
import TableHeader from "../../Components/DataTable/TableHeader";
import CustomerForm from "./AddCustomers";

const styles = {
  tableContainer: {
    margin: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  thTd: {
    padding: "8px",
    border: "1px solid #ddd",
    textAlign: "left",
  },
  activeStatus: {
    color: "green",
  },
  inactiveStatus: {
    color: "red",
  },
  vehicleDropdown: {
    padding: "8px",
    border: "1px solid #ddd",
    width: "100%",
    marginBottom: "10px",
  },
  card: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    margin: '10px 0',
    padding: '15px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '10px'
  },
  cardItem: {
    marginBottom: '5px'
  },
  statusText: {
    fontSize: '12px'
  }
};

const CustomerTable = () => {
  const [customers, setCustomers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [vehicles, setVehicles] = useState([]);
  const [newpo, setNewpo] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const result = await getCustomers();
        setCustomers(result);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    const fetchData = async () => {
      try {
        const result = await getVehicles();
        setVehicles(result);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      }
    };

    fetchUsers();
    fetchData();

    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleRowClick = (user) => {
    setSelectedUser(user);
  };

  if (newpo) {
    return (
      <div>
        <TableHeader
          title="Add Customer"
          showAddButton={false}
          showBackButton={true}
          onBack={() => setNewpo(false)}
          showPrintButton={false}
          showExcelButton={false}
          showPdfButton={false}
        />
        <CustomerForm setNewpo={() => setNewpo(false)} />
      </div>
    );
  }

  return (
    <div style={styles.tableContainer}>
      <TableHeader
        title="Customer List"
        showAddButton={true}
        showBackButton={false}
        onAdd={() => setNewpo(true)}
        showPrintButton={true}
        showExcelButton={true}
        showPdfButton={true}
      />
      {isSmallScreen ? (
        // Render cards for small screens
        customers.map((customer, index) => (
          <div key={index} style={styles.card}>
            <div style={styles.cardTitle}>{customer.CustomerName || "N/A"}</div>
            <div style={styles.cardItem}>Address: {customer.Address || "N/A"}</div>
            <div style={styles.cardItem}>Location: {customer.Location || "N/A"}</div>
            <div style={styles.cardItem}>Date Added: {new Date(customer.DateAdded).toLocaleString()}</div>
            <div style={{...styles.cardItem, ...styles.statusText}}>
              Status: 
              <span 
                style={customer.StatusID === 1 ? styles.activeStatus : styles.inactiveStatus}
              >
                {customer.StatusID === 1 ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
        ))
      ) : (
        // Render table for larger screens
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.thTd}>Customer Name</th>
              <th style={styles.thTd}>Address</th>
              <th style={styles.thTd}>Location</th>
              <th style={styles.thTd}>Date Added</th>
              <th style={styles.thTd}>Status</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((customer) => (
              <tr
                key={customer.CustomerID}
                onClick={() => handleRowClick(customer)}
                style={{ cursor: "pointer" }}
              >
                <td style={styles.thTd}>{customer.CustomerName || "N/A"}</td>
                <td style={styles.thTd}>{customer.Address || "N/A"}</td>
                <td style={styles.thTd}>{customer.Location || "N/A"}</td>
                <td style={styles.thTd}>
                  {new Date(customer.DateAdded).toLocaleString()}
                </td>
                <td style={styles.thTd}>
                  <span
                    style={
                      customer.StatusID === 1
                        ? styles.activeStatus
                        : styles.inactiveStatus
                    }
                  >
                    {customer.StatusID === 1 ? "Active" : "Inactive"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CustomerTable;